export type RecentItemType = 'chatbot' | 'conversation' | 'test' | 'user' | 'knowledge-base';

export interface BaseRecentItem {
  type: RecentItemType;
  timestamp: number;
  route: string[];
}

export interface RecentChatbotItem extends BaseRecentItem {
  type: 'chatbot';
  code: string;
  name: string;
}

export interface RecentConversationItem extends BaseRecentItem {
  type: 'conversation';
  id: string;
  title: string;
  chatbotCode: string;
}

export interface RecentTestItem extends BaseRecentItem {
  type: 'test';
  id: string;
  name: string;
}

export interface RecentUserItem extends BaseRecentItem {
  type: 'user';
  id: string;
  name: string;
  email: string;
}

export interface RecentKnowledgeBaseItem extends BaseRecentItem {
  type: 'knowledge-base';
  code: string;
  name: string;
}

export type RecentItem =
  | RecentChatbotItem
  | RecentConversationItem
  | RecentTestItem
  | RecentUserItem
  | RecentKnowledgeBaseItem;

export const RECENT_ITEMS_KEYS = {
  CHATBOTS: 'recent_chatbots',
  CONVERSATIONS: 'recent_conversations',
  TESTS: 'recent_tests',
  USERS: 'recent_users',
  KNOWLEDGE_BASES: 'recent_knowledge_bases',
  ALL: 'recent_items_all',
} as const;
